import React from 'react';
import { BsTwitter, BsInstagram, BsLinkedin } from 'react-icons/bs';
import { FaFacebookF} from 'react-icons/fa';


const SocialMedia = () => {
  return (
    <div className="app__social">
          <div >
              <a href="https://twitter.com/1_Krishna_1" target="_blank" rel="noreferrer"><BsTwitter/></a>
          </div>
           <div >
              <a href="https://www.facebook.com/krishna.bhatta.9041083" target="_blank" rel="noreferrer"><FaFacebookF/></a>
          </div>
           {/* <div >
              <a href="https://www.instagram.com/kris_hnabhatta/?__coig_restricted=1" target="_blank" rel="noreferrer"><BsInstagram/></a>
        </div> */}
           <div >
              <a href="https://www.instagram.com/kris_hnabhatta/?__coig_restricted=1" target="_blank" rel="noreferrer"><BsLinkedin/></a>
        </div>
    </div>
  )
}

export default SocialMedia